import React from 'react';

const Footer = () => {
    return (
        <footer>
            <div className="text-center p-3">
            <small>©2021.<span style={{color: '#6047EC',fontSize:'20px'}}>Shakil Ahmed</span> . All rights reserved. Dhaka, Bangladesh.</small>
        </div>
        </footer>
    );
};

export default Footer;